import React, { useState, useMemo } from 'react';

// --- ICONS (for a real app, use an icon library or SVGs) ---
const SearchIcon = ({ className }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>
);
const UserIcon = ({ className }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>
);
const FileIcon = ({ className }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}><path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"></path><polyline points="13 2 13 9 20 9"></polyline></svg>
);
const SettingsIcon = ({ className }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}><circle cx="12" cy="12" r="3"></circle><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path></svg>
);


// --- MOCK DATA ---
// Using the provided date: Tuesday, September 23, 2025 at 6:20 PM IST
const MOCK_LOG_DATA = [
    { id: 1, action: "User login", user: "alex@example.com", ip: "103.22.201.125", location: "Mumbai, India", timestamp: "2025-09-23T18:15:30.000Z", status: "Success", icon: UserIcon },
    { id: 2, action: "Updated profile settings", user: "alex@example.com", ip: "103.22.201.125", location: "Mumbai, India", timestamp: "2025-09-23T18:10:11.000Z", status: "Success", icon: SettingsIcon },
    { id: 3, action: "Failed login attempt", user: "guest@example.com", ip: "192.168.1.10", location: "Unknown", timestamp: "2025-09-23T17:55:45.000Z", status: "Failure", icon: UserIcon },
    { id: 4, action: "Uploaded file: report-q3.pdf", user: "sara@example.com", ip: "157.32.118.90", location: "Delhi, India", timestamp: "2025-09-23T16:30:05.000Z", status: "Success", icon: FileIcon },
    { id: 5, action: "API key generated", user: "admin@corp.com", ip: "202.142.78.34", location: "Bengaluru, India", timestamp: "2025-09-23T14:20:19.000Z", status: "Success", icon: SettingsIcon },
    { id: 6, action: "User login", user: "sara@example.com", ip: "157.32.118.90", location: "Delhi, India", timestamp: "2025-09-23T13:05:00.000Z", status: "Success", icon: UserIcon },
    { id: 7, action: "User logout", user: "alex@example.com", ip: "103.22.201.125", location: "Mumbai, India", timestamp: "2025-09-22T20:01:50.000Z", status: "Success", icon: UserIcon },
    { id: 8, action: "Deleted file: old_data.csv", user: "admin@corp.com", ip: "202.142.78.34", location: "Bengaluru, India", timestamp: "2025-09-22T11:45:10.000Z", status: "Success", icon: FileIcon },
    { id: 9, action: "Failed login attempt", user: "alex@example.com", ip: "103.22.201.125", location: "Mumbai, India", timestamp: "2025-09-22T09:12:22.000Z", status: "Failure", icon: UserIcon },
    { id: 10, action: "User login", user: "john@example.com", ip: "210.212.180.11", location: "Pune, India", timestamp: "2025-09-21T15:00:00.000Z", status: "Success", icon: UserIcon },
];

const LOGS_PER_PAGE = 5;

// --- UI COMPONENTS ---
const SectionCard = ({ children, title, subtitle }) => ( 
    <div>
        <h2 className="text-2xl font-bold text-slate-900">{title}</h2>
        <p className="mt-1 text-sm text-slate-600">{subtitle}</p>
        <div className="mt-6">{children}</div>
    </div>
);
const Card = ({ children, className }) => ( 
    <div className={`bg-white/70 backdrop-blur-sm p-0 rounded-2xl shadow-lg border border-white/50 overflow-hidden ${className}`}>
        {children}
    </div>
);
const StatusBadge = ({ status }) => {
    const isSuccess = status === 'Success';
    return (
        <span className={`px-2 py-1 text-xs font-semibold rounded-full inline-flex items-center gap-1.5 ${isSuccess ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`}>
            <span className={`h-1.5 w-1.5 rounded-full ${isSuccess ? 'bg-green-500' : 'bg-red-500'}`}></span>
            {status}
        </span>
    );
};

// --- MAIN COMPONENT ---
const AuditLog = () => {
    const [searchTerm, setSearchTerm] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    
    const filteredLogs = useMemo(() => {
        return MOCK_LOG_DATA.filter(log =>
            log.action.toLowerCase().includes(searchTerm.toLowerCase()) ||
            log.user.toLowerCase().includes(searchTerm.toLowerCase()) ||
            log.ip.toLowerCase().includes(searchTerm.toLowerCase())
        );
    }, [searchTerm]);

    const totalPages = Math.ceil(filteredLogs.length / LOGS_PER_PAGE);
    const displayedLogs = filteredLogs.slice((currentPage - 1) * LOGS_PER_PAGE, currentPage * LOGS_PER_PAGE);

    const formatTimestamp = (isoString) => {
        return new Date(isoString).toLocaleString('en-IN', { 
            dateStyle: 'medium', 
            timeStyle: 'short',
            timeZone: 'Asia/Kolkata' 
        });
    };

    return (
        <SectionCard title="Audit Log" subtitle="Track important activities and security events across your account.">
            <Card>
                {/* Header with Search */}
                <div className="p-4 sm:p-6 border-b border-slate-200">
                    <div className="relative max-w-xs">
                        <SearchIcon className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-slate-400" />
                        <input
                            type="text"
                            placeholder="Search logs..."
                            value={searchTerm}
                            onChange={(e) => { setSearchTerm(e.target.value); setCurrentPage(1); }}
                            className="w-full pl-10 pr-4 py-2 bg-white border border-slate-300 rounded-lg shadow-sm focus:ring-blue-500 focus:border-blue-500"
                        />
                    </div>
                </div>

                {/* Log Table/List */}
                <div className="overflow-x-auto">
                    <table className="w-full text-sm text-left text-slate-600">
                        <thead className="text-xs text-slate-700 uppercase bg-slate-50">
                            <tr>
                                <th scope="col" className="px-6 py-3">Event</th>
                                <th scope="col" className="px-6 py-3">User</th>
                                <th scope="col" className="px-6 py-3">Source</th>
                                <th scope="col" className="px-6 py-3">Date</th>
                                <th scope="col" className="px-6 py-3">Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            {displayedLogs.map(log => (
                                <tr key={log.id} className="bg-white border-b hover:bg-slate-50">
                                    <td className="px-6 py-4">
                                        <div className="flex items-center gap-3">
                                            <div className="flex-shrink-0 bg-slate-100 rounded-full p-2">
                                                <log.icon className="w-5 h-5 text-slate-500" />
                                            </div>
                                            <span className="font-medium text-slate-800">{log.action}</span>
                                        </div>
                                    </td>
                                    <td className="px-6 py-4">{log.user}</td>
                                    <td className="px-6 py-4">
                                        <div>{log.ip}</div>
                                        <div className="text-xs text-slate-500">{log.location}</div>
                                    </td>
                                    <td className="px-6 py-4 whitespace-nowrap">{formatTimestamp(log.timestamp)}</td>
                                    <td className="px-6 py-4"><StatusBadge status={log.status} /></td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                {filteredLogs.length === 0 && (
                    <p className="text-center text-slate-500 p-10">
                        No audit logs found for "{searchTerm}".
                    </p>
                )}

                {/* Pagination */}
                {totalPages > 1 && (
                    <div className="p-4 sm:p-6 border-t border-slate-200 flex items-center justify-between">
                         <span className="text-sm text-slate-700">
                            Page <span className="font-semibold">{currentPage}</span> of <span className="font-semibold">{totalPages}</span>
                        </span>
                        <div className="inline-flex rounded-md shadow-sm" role="group">
                            <button 
                                onClick={() => setCurrentPage(p => Math.max(1, p - 1))}
                                disabled={currentPage === 1}
                                className="px-4 py-2 text-sm font-medium text-slate-900 bg-white border border-slate-200 rounded-l-lg hover:bg-slate-100 disabled:opacity-50 disabled:cursor-not-allowed"
                            >
                                Previous
                            </button>
                            <button 
                                onClick={() => setCurrentPage(p => Math.min(totalPages, p + 1))}
                                disabled={currentPage === totalPages}
                                className="px-4 py-2 text-sm font-medium text-slate-900 bg-white border border-slate-200 rounded-r-lg hover:bg-slate-100 disabled:opacity-50 disabled:cursor-not-allowed"
                            >
                                Next
                            </button>
                        </div>
                    </div>
                )}
            </Card>
        </SectionCard>
    );
};

export default AuditLog;